import styled from '@emotion/styled'
import { Box, Stack, ThemeProvider } from '@mui/material'
import { MainTemplate } from 'Components/Template/MainTemplate'
import { observer } from 'mobx-react-lite'
import CircularProgress from '@mui/material/CircularProgress'
import { useNavigate } from 'react-router-dom'
import { useLayoutEffect } from 'react'
import { get } from 'lodash'

const PaymentResponseDone = observer(() => {
    const navigate = useNavigate()
    const qs = new URLSearchParams(window.location.search)
    const isInIframe = window.self !== window.top

    useLayoutEffect(() => {
        const paymentID = qs.get('payment_id') || sessionStorage.getItem('paymentID')

        if (qs.get('tppPayload')) {
            try {
                const payload = JSON.parse(qs.get('tppPayload'))
                const orderId = get(payload, 'eventDetails.id.unicity')
                const errorMessage = get(payload, 'eventDetails.error.error_message') || get(payload, 'eventDetails.error')

                if (orderId) {
                    UpdatePaymentStatus(paymentID, 'success', { orderId })
                } else {
                    UpdatePaymentStatus(paymentID, 'failed', { errorMessage })
                }
            } catch (e) {
                UpdatePaymentStatus(paymentID, 'failed', {})
            }
        } else if (paymentID) {
            UpdatePaymentStatus(paymentID, 'failed', {})
        }
    }, [])

    const UpdatePaymentStatus = async (paymentID, status, extra = {}) => {
        if (isInIframe) {
            window.parent.postMessage(
                {
                    type: status === 'success' ? 'WP_3DS_SUCCESS' : 'WP_3DS_FAILED',
                    payment_id: paymentID,
                    order_id: extra.orderId || '',
                    error_message: extra.errorMessage || ''
                },
                '*'
            )
            return
        }

        setTimeout(() => {
            try {
                if (status === 'success') {
                    // order_number is the fallback key — sessionStorage paymentID does not survive the gateway redirect in every browser
                    navigate(`/payment-response/success?payment_id=${paymentID}${extra.orderId ? `&order_number=${extra.orderId}` : ''}`)
                } else {
                    navigate(`/payment-response/failed?payment_id=${paymentID}`)
                }
            } catch (e) {
                navigate(`/payment-response/failed?payment_id=${paymentID}`)
                console.log('error => ', e)
            }
        }, 1000)
    }

    return (
        <ThemeProvider theme={MainTemplate}>
            <PaymentResponseDoneWrapper>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                    <CircularProgress />
                </Box>
            </PaymentResponseDoneWrapper>
        </ThemeProvider>
    )
})

const PaymentResponseDoneWrapper = styled(Stack)`
    width: 100%;
    min-height: calc(100vh - (74px + 64px));
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 20px 20px 140px 20px;
    box-sizing: border-box;

    @media (min-width: 744px) {
        padding: 40px 0 54px 0;
    }
`

export default PaymentResponseDone
